function loadMore(buttonLoad ,conForLoad){
    const thisButton = document.querySelector(buttonLoad);
    const curOffsetVal = parseInt(thisButton.dataset.curOffset);
    const howMuchLoadVal = parseInt(thisButton.dataset.howMuchLoad);
    const countAllPostsVal = parseInt(thisButton.dataset.countAllPosts);
    const howMuchShowVal = parseInt(thisButton.dataset.howMuchShow);

    var data = {
        'action': 'loadmore',
        'how_much_load': howMuchLoadVal,
        'cur_offset': curOffsetVal
    };

    jQuery(function($){
        $.ajax({
            url: thisButton.dataset.siteUrl,
            data: data,
            type: 'POST',
            dataType: "json",
            success:function(data){
                $(conForLoad).append(data['out']);

                let updateOffset = curOffsetVal + howMuchLoadVal;
                thisButton.dataset.curOffset = updateOffset;

                if(countAllPostsVal <= curOffsetVal + howMuchLoadVal){
                    thisButton.style.display = 'none';
                }
            }
        });
    });
}
module.exports = loadMore;